import {
  readConfigBoolean,
  readConfigNumber,
  readConfigString,
} from '../config/frontendConfig';

export interface BrowserTelemetryConfig {
  enabled: boolean;
  endpoint: string;
  debug: boolean;
  environment: string;
  serviceVersion: string;
  maxResourceEntries: number;
}

export function getBrowserTelemetryConfig(): BrowserTelemetryConfig {
  return {
    enabled: readConfigBoolean('app.telemetry.browser.enabled', false),
    endpoint: readConfigString(
      'app.telemetry.browser.endpoint',
      '/api/tenant-management/telemetry/browser',
    ),
    debug: readConfigBoolean('app.telemetry.browser.debug', false),
    environment: readConfigString(
      'auth.environment',
      process.env.NODE_ENV ?? 'development',
    ),
    serviceVersion: readConfigString('app.version', '0.0.0'),
    maxResourceEntries: readConfigNumber(
      'app.telemetry.browser.maxResourceEntries',
      50,
    ),
  };
}
